import * as types from "../actions/types/budget.types";
import moment from "moment";

const initialState = {
  budgetState: "initial",
  fetchDataErrMsg: null,
  budgetData: [],
  budgetSet: [],
  budgetStartDate: moment().startOf("month"),
  budgetEndDate: moment().endOf("month"),
  budgetFixedStartDate: moment().startOf("month"),
  budgetFixedEndDate: moment().endOf("month"),
  createBudgetModal: false,
  balanceModal: false,
  fixedBudget: [],
  categories: {
    active: "",
    data: [],
  },
  newCreateBudgetModal: false
};

export const budgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_BUDGET_START_DATE:
      return {
        ...state,
        budgetStartDate: action.payload,
      };
    case types.CHANGE_BUDGET_END_DATE:
      return {
        ...state,
        budgetEndDate: action.payload,
      };
    case types.GET_TRANSACTIONS_STARTED:
      return {
        ...state,
        budgetState: "loading",
      };
    case types.GET_TRANSACTIONS_SUCCEEDED:
      return {
        ...state,
        budgetState: "success",
        budgetData: action.payload,
      };
    case types.SHOW_CREATE_MODAL:
      return {
        ...state,
        newCreateBudgetModal: true,
      };
    case types.HIDE_CREATE_MODAL:
      return {
        ...state,
        newCreateBudgetModal: false,
      };
    default:
      return state;
  }
};
